// extracted by mini-css-extract-plugin
export default {"vacancyContactsLine":"vacancyContactsLine-module__vacancyContactsLine--pCJVe","link":"vacancyContactsLine-module__link--xReU3"};